import { render } from "./ButtonPhone.vue?vue&type=template&id=33136279&scoped=true"
import script from "./ButtonPhone.vue?vue&type=script&lang=js"
export * from "./ButtonPhone.vue?vue&type=script&lang=js"

import "./ButtonPhone.vue?vue&type=style&index=0&id=33136279&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33136279"]])

export default __exports__